module.exports = __webpack_public_path__ + "static/media/4전쟁-빈공장의기타소리.b3c819fa.mp3";